import AssigneeSelector from '../../conversations/AssigneeSelector';
import { useDmNotificationAssignment } from '../../../hooks/useDmNotificationAssignment';
import type { DmNotificationPatientRow } from '../../../services/dmNotifications';

// Assignment is per patient and shared by the notifications and messages lists.
export type AssignablePatient = Pick<
    DmNotificationPatientRow,
    'patientId' | 'patientName' | 'assignee'
>;

interface NotificationAssigneeCellProps {
    row: AssignablePatient;
    // Opens the menu upwards for rows near the bottom of the clipped scroll body.
    dropUp: boolean;
    align?: 'left' | 'right';
}

// A component, not a render callback: DataTable calls `render` as a plain function, and this needs a hook.
export function NotificationAssigneeCell({
    row,
    dropUp,
    align = 'left'
}: NotificationAssigneeCellProps) {
    const { currentUserEmail, handleAssign, handleUnassign } = useDmNotificationAssignment(
        row.patientId
    );
    return (
        <AssigneeSelector
            assignedTo={row.assignee?.email ?? null}
            dropUp={dropUp}
            dropdownAlign={align}
            onAssign={handleAssign}
            onUnassign={handleUnassign}
            currentUserEmail={currentUserEmail}
            ariaLabel={`Assignee for ${row.patientName}`}
        />
    );
}
